import {WmWoundAnswerOption} from '../../interfaces/wound-management/wm-wound-answer-option';
import {WmWoundAnswer} from '../../interfaces/wound-management/wm-wound-answer';
import {WmWoundQuestion} from '../../interfaces/wound-management/wm-wound-question';

export class WmWoundAnswerOptionFactory {

  /**
   *
   * @param wmWoundAnswerOption
   */
  public static fromObject(wmWoundAnswerOption: any): WmWoundAnswerOption {
    return new class implements WmWoundAnswerOption {
      created: string = wmWoundAnswerOption.created;
      description: string = wmWoundAnswerOption.description;
      id: number = wmWoundAnswerOption.id;
      modified: string = wmWoundAnswerOption.modified;
      name: string = wmWoundAnswerOption.name;
      parentId: number = wmWoundAnswerOption.parent_id;
      wmWoundAnswerOptions: WmWoundAnswerOption[] =
        wmWoundAnswerOption.wm_wound_answer_options ?
          WmWoundAnswerOptionFactory.fromArray(wmWoundAnswerOption.wm_wound_answer_options) : [];
      wmWoundQuestionId: number = wmWoundAnswerOption.wm_wound_question_id;
    };
  }

  /**
   *
   */
  public static fromWmWoundQuestion(wmWoundQuestion: WmWoundQuestion): WmWoundAnswerOption {
    return new class implements WmWoundAnswerOption {
      created: string = null;
      description: string = null;
      id: number = null;
      modified: string = null;
      name: string = null;
      parentId: number = null;
      wmWoundAnswers: WmWoundAnswer[] = [];
      wmWoundQuestionId: number = wmWoundQuestion.id;
      wmWoundAnswerOptions: WmWoundAnswerOption[] = [];
    };
  }

  /**
   *
   * @param wmWoundAnswerOptions
   */
  public static fromArray(wmWoundAnswerOptions: any[]): WmWoundAnswerOption[] {
    return wmWoundAnswerOptions.map(_wmWoundAnswerOption => WmWoundAnswerOptionFactory.fromObject(_wmWoundAnswerOption));
  }
}
